function getURLQueryParameter(name) {
  var query = window.location.search.substring(1),
    vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == name) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
}
// Check Valid JSON and return object if json valid
function parseJSONObjFnc(str) {
  try {
    var o = JSON.parse(str);
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {}
  return false;
}

setTimeout(function () {
  if (document.referrer.indexOf('/search') >= 0) {
    var searchUuid = getURLQueryParameter('searchUuid'),
      isSupported = false,
      url = new URL(window.location);

    url.searchParams.delete('searchUuid');
    window.history.replaceState({}, '', url.toString());

    // adding try catch for localstorage
    try {
      isSupported = window.localStorage ? true : false;
    } catch (e) {}

    if (isSupported) {
      var conversionMetricData = localStorage.getItem('algoliaConversionMetricData_' + searchUuid);
      if (conversionMetricData) {
        localStorage.removeItem('algoliaConversionMetricData_' + searchUuid);
        conversionMetricData = parseJSONObjFnc(conversionMetricData);
        var searchConverted = false;

        // ----- Script Provided by Algolia for the insights library ------

        var ALGOLIA_INSIGHTS_SRC = conversionMetricData.algoliaInsightsSrc;
        // e = window, a = document, t = "script", n = ALGOLIA_INSIGHTS_SRC, s = "aa", i = param1, c = param2
        !(function (e, a, t, n, s, i, c) {
          (e.AlgoliaAnalyticsObject = s),
            (e[s] =
              e[s] ||
              function () {
                (e[s].queue = e[s].queue || []).push(arguments);
              }),
            (i = a.createElement(t)),
            (c = a.getElementsByTagName(t)[0]),
            (i.async = 1),
            (i.src = n),
            c.parentNode.insertBefore(i, c);
        })(window, document, 'script', ALGOLIA_INSIGHTS_SRC, 'aa');

        // ----- End ------

        aa('init', {
          appId: conversionMetricData.appId,
          apiKey: conversionMetricData.apiKey,
        });

        // Set Timeout Conversion
        var secondsCounter = 0,
          counterPaused =
            typeof document.visibilityState === 'undefined' ? false : document.visibilityState === 'hidden',
          conversionThreshold = parseInt(conversionMetricData.conversionMetricsSetTimeoutDuration) || 10;

        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'hidden') {
            counterPaused = true;
          } else {
            counterPaused = false;
          }
        });

        // Conversion Set Interval
        var conversionInterval = setInterval(function () {
          if (searchConverted) {
            clearInterval(conversionInterval);
            return;
          }

          if (!counterPaused && !searchConverted) {
            secondsCounter = secondsCounter + 1;
            if (secondsCounter >= conversionThreshold) {
              window.aa('convertedObjectIDsAfterSearch', {
                eventName: 'search_conversion_set_timeout',
                userToken: conversionMetricData.userToken,
                index: conversionMetricData.index,
                queryID: conversionMetricData.queryID,
                objectIDs: conversionMetricData.objectIDs,
              });
              searchConverted = true;
              clearInterval(conversionInterval);
              return;
            }
          }
        }, 1000);

        // Scroll to bottom conversion
        window.addEventListener('scroll', function () {
          if (
            !searchConverted &&
            window.innerHeight + window.pageYOffset > document.documentElement.scrollHeight - 100
          ) {
            window.aa('convertedObjectIDsAfterSearch', {
              eventName: 'search_conversion_scroll_to_bottom',
              userToken: conversionMetricData.userToken,
              index: conversionMetricData.index,
              queryID: conversionMetricData.queryID,
              objectIDs: conversionMetricData.objectIDs,
            });
            searchConverted = true;
          }
        });
      }
    }
  }
}, 100);
